import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { colors, ColorVariant, cssVar } from "./colors";

interface StyledButtonProps {
	variant: ColorVariant;
	size?: "sm" | "md" | "lg";
	outlined?: boolean;
}
const StyledButton = styled.button<StyledButtonProps>(
	({ variant, size, outlined }) => css`
		${size === "lg"
			? css`
					font-size: 1.2em;
					padding: 8px 15px;
			  `
			: size === "sm"
			? css`
					font-size: 0.8em;
					padding: 2px 8px;
			  `
			: // size === 'md'
			  css`
					font-size: 1em;
					padding: 5px 15px;
			  `}
		${!!outlined
			? css`
					background-color: ${colors[variant].textColor};
					color: ${colors[variant].bgColor};
			  `
			: css`
					background-color: ${colors[variant].bgColor};
					color: ${colors[variant].textColor};
			  `}
		position: relative;
		cursor: pointer;
		margin: 3px 1px 3px 1px;
		border: unset;
		border: 1px solid ${colors[variant].borderColor};
		border-radius: ${cssVar("border-radius-1")};
		box-shadow: 0 2px 1px ${colors[variant].borderColor};
		transition: 200ms background-color, 200ms color;
		&:hover,
		&:focus-visible {
			box-shadow: 0 4px 1px ${colors[variant].borderColor};
			transform: translateY(-2px);
			${!!outlined
				? css`
						background-color: ${colors[variant].bgColor};
						color: ${colors[variant].textColor};
				  `
				: ""}
		}
		&:active {
			box-shadow: 0 0 1px ${colors[variant].borderColor};
			transform: translateY(2px);
		}
		&:focus-visible {
			outline: none;
		}
		&:focus-visible:before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: -4px;
			border-radius: ${cssVar("border-radius-1")};
			outline-offset: 5px;
			outline: 2px solid ${colors[variant].borderColor};
		}
		&:focus-visible:active:before {
			bottom: 0px;
		}
		&:disabled {
			opacity: 0.75;
			cursor: not-allowed;
			box-shadow: 0 0 1px ${colors[variant].borderColor};
			transform: translateY(2px);
		}
	`
);

/**
 * Overrides the default button props.
 */
export const Button = (
	props: StyledButtonProps & React.HTMLAttributes<HTMLButtonElement>
) => {
	return <StyledButton {...props}>{props.children}</StyledButton>;
};
